import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://dihllybgrjubhyhyainp.supabase.co'
const SUPABASE_ANON_KEY = 'sb_publishable_XqOOAisnRiFJgZElEXnrMQ_DvLHr-dv'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
